(function () {
    'use strict';

    angular
        .module('externalPartyEditModule')
        .controller('ODDCampaignQuestionnaireEditController', Controller);

    Controller.$inject = ['$scope', '$state', 'modalService', 'externalParty', 'campaign', 'questionnaire'];

    function Controller($scope, $state, modalService, externalParty, campaign, questionnaire) {
        $scope.externalParty = externalParty;
        $scope.campaign = campaign;
        $scope.questionnaire = questionnaire;

        $scope.goToExternalParty = function () {
            $state.go('odd.externalPartyEdit');
        };

        $scope.goToCampaign = function () {
            $state.go('odd.externalPartyEdit.campaign', { ODDCampaignID: campaign.ODDCampaignID });
        };

        $scope.goToSectionListEdit = function () {
            $state.go('odd.externalPartyEdit.campaign.questionnaire.editSectionList');
        };

        $scope.addSection = function () {
            modalService.displayTemplateModal(
                'Choose a Section from Questionnaire Template',
                require('./campaignQuestionnaireSectionAddModal.tpl.html'),
                { campaign: campaign, questionnaire: questionnaire },
                false
            );
        };
    }
})();
